// export const baseUrl = 'http://labs.lancelotmobile.com:9780/api/v1';

export const host = process.env.VUE_APP_BASE_SERVER_URL
export const baseUrl = `${host}/api/v1`
export const allTrips = `${baseUrl}/trip/all`
// process.env.BASE_SERVER_URL + process.env.API_PATH;
